var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignInIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 3V5H19.0001V19H12.0001V21H19.0061C20.1061 21 21.0001 20.107 21.0001 19.005V4.995C21.0003 4.73302 20.9489 4.47357 20.8488 4.23147C20.7487 3.98937 20.6019 3.76938 20.4167 3.58409C20.2315 3.3988 20.0116 3.25184 19.7695 3.15161C19.5275 3.05139 19.268 2.99987 19.0061 3H12.0001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97706 11C3.71484 11.0034 3.46469 11.1108 3.28152 11.2984C3.09835 11.4861 2.99713 11.7388 3.00006 12.001C3.00006 12.552 3.43706 13 3.97706 13H15.0241C15.2859 12.9968 15.5358 12.8898 15.7188 12.7025C15.9018 12.5152 16.003 12.2629 16.0001 12.001C16.003 11.7389 15.9019 11.4864 15.719 11.2988C15.536 11.1111 15.2861 11.0037 15.0241 11H3.97706Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3031 8.305C12.109 8.502 12.0002 8.76745 12.0002 9.044C12.0002 9.32055 12.109 9.586 12.3031 9.783L14.5001 12L12.3031 14.217C12.1089 14.4135 12 14.6787 12 14.955C12 15.2313 12.1089 15.4965 12.3031 15.693C12.7071 16.102 13.3631 16.102 13.7681 15.693L16.6981 12.738C16.8914 12.5408 16.9996 12.2756 16.9996 11.9995C16.9996 11.7234 16.8914 11.4582 16.6981 11.261L13.7681 8.305C13.672 8.20858 13.5578 8.13207 13.4321 8.07987C13.3064 8.02767 13.1717 8.00079 13.0356 8.00079C12.8995 8.00079 12.7647 8.02767 12.639 8.07987C12.5133 8.13207 12.3991 8.20858 12.3031 8.305Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInIcon);
export default __webpack_public_path__ + "static/media/_SignInIcon_.6176ab98f8c793c3bf18dc0525a5d364.svg";
export { ForwardRef as ReactComponent };